import { toDate } from 'date-fns';
import { getTimezoneOffset } from 'date-fns-tz';
import { DatetimeStruct } from './datetime-struct';
import { isEmpty } from './object-util';

/**
 * Convert the date from the given time zone to the local time.
 *
 * Ported from date-fns-timezone to work with date-fns 2.x:
 * https://github.com/prantlf/date-fns-timezone/blob/eeaeeb6b39edec021f37db5790b841055a05aa48/src/convertToLocalTime.js
 *
 * @param value the value to convert
 * @param timezone the time zone
 * @returns the parsed date in the local time zone
 */
export function convertToLocalTime(value: Date | number, timezone: string) {
  const date = toDate(value);
  let offset = getTimezoneOffset(timezone, value) / (60 * 1000);
  offset = date.getTimezoneOffset() + offset;
  return new Date(date.getTime() - offset * 60 * 1000);
}

export function getFullFormTimezone(abbreviation: string): string {
  if (isEmpty(abbreviation)) {
    return 'Etc/UTC';
  }

  switch (abbreviation) {
    case 'EDT':
    case 'EST':
      return 'America/New_York';

    case 'CDT':
    case 'CST':
      return 'America/Chicago';

    case 'MST':
    case 'MDT':
      return 'America/Denver';

    case 'PST':
    case 'PDT':
      return 'America/Los_Angeles';

    case 'IST':
      return 'Asia/Kolkata';

    case 'SAST':
      return 'Africa/Johannesburg';

    case 'EAT':
      return 'Africa/Dar_es_Salaam';

    case 'WAT':
      return 'Africa/Douala';

    case 'CAT':
      return 'Africa/Gaborone';

    case 'GMT':
      return 'Africa/Freetown';

    default:
      return 'Etc/UTC';
  }
}

export function getDateFromDatetimeStruct(datetimeStruct: DatetimeStruct, includeTime = true): Date {
  return new Date(
    datetimeStruct.year,
    datetimeStruct.month - 1,
    datetimeStruct.day,
    includeTime ? datetimeStruct.hour || 0 : 0,
    includeTime ? datetimeStruct.minute || 0 : 0,
    includeTime ? datetimeStruct.second || 0 : 0
  );
}
